const styles = {
  wrap: {
    width: '100%',
    '& .react-tel-input': {
      display: 'flex',
      '& .flag-dropdown': {
        position: 'relative',
        order: 1,
        marginRight: 10,
        border: '1px solid #E2E2FC',
        backgroundColor: '#FFFFFF',
        borderRadius: 8,
        '& .selected-flag': {
          backgroundColor: 'transparent',
          width: 55,
          '& .arrow': {
            content:
              'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEzIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjUgMUw2LjUgNkwxMS41IDEiIHN0cm9rZT0iIzEzMEYyNiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K")',
            border: 'none',
            display: 'block',
            width: 13,
            height: 7,
            marginTop: -4,
            left: 25,
            '&.up': {
              transform: 'rotate(180deg)',
            },
          },
        },
        '& .selected-flag:hover, &.open .selected-flag': {
          backgroundColor: 'transparent',
        },
      },
      '& .form-control': {
        width: '100%',
        border: '1px solid #E2E2FC',
        borderRadius: 8,
        padding: '0 12px',
        backgroundColor: '#FFFFFF',
        height: 40,
        fontSize: 16,
        boxShadow: 'none',
        color: 'black',
        order: 2,
      },
      '& .country-list': {
        '& .search-emoji': {
          display: 'none',
        },
        '& .search-box': {
          marginLeft: 0,
          width: '100%',
          border: '1px solid #E2E2FC',
          borderRadius: 8,
          padding: '0 12px',
          backgroundColor: '#FFFFFF',
          height: 40,
          fontSize: 14,
          boxShadow: 'none',
          color: 'black',
        },
      },
    },
  },
  label: {
    fontSize: 14,
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
  },
  error: {
    fontSize: 12,
    color: '#FF0000',
    marginBottom: 1,
  },
  emptyMargin: {
    height: 18,
  },
}
export { styles }
